<template>
  <HScaffold title="返水" :hideNav="hideNav" :desktopAlignHeader="tag === 'tabReward'" :desktopFull="isDesktop && !tag">
    <div style="display:flex;flex-direction: row;padding:5px;">
      <div class="ximaLeftCol" style="display: flex;flex-direction: column;width:100px;margin-right: 3px;">
        <div @click="changeSwiperPage(index)" v-for="(item, index) in leftIconInfo" :key="index" :style="{
          backgroundColor:activeSwiperIndex === index?hcf.getMainColor()+'cc':hcf.getMainColor()+'1a',
        }" class="eachLeftDiv">
          <img :src="item['icon']" :style="['height:15px',activeSwiperIndex === index || HNewGameUIConfig.newGameUIType !== 0?'filter: brightness(0) invert(1);':'']" alt="">
          <div :style="hcf.getTextStyle({
            color:activeSwiperIndex === index?'white':'main',addSize:-2,marginLeft:2,
        })">{{item["title"]}}</div>
        </div>
      </div>
      <HSwiperLR ref="swiperLrRef" :height="swiperHeight" :data="[1,2,3]" :onSwipeChange="onSwipeChange">
        <template #default="{ items, pageIndex }">
          <XimaFanshui v-if="pageIndex === 0"/>
          <FanshuiHistory :tag="tag" v-if="pageIndex === 1"/>
          <XimaHistory v-if="pageIndex === 2"/>
        </template>
      </HSwiperLR>
    </div>
    <HDatePicker v-if="!tag" onlyShowPopup="true"/>
  </HScaffold>

</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import icon_left_fs from "@/assets/icons/discount/xm_left_fs.png";
  import icon_left_xmfs from "@/assets/icons/discount/xm_left_xmfs.png";
  import icon_left_xmjl from "@/assets/icons/discount/xm_left_xmjl.png";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import XimaFanshui from "@/components/pages/Discount/XimaFanshui.vue";
  import FanshuiHistory from "@/components/pages/Discount/FanshuiHistory.vue";
  import XimaHistory from "@/components/pages/Discount/XimaHistory.vue";
  import HDatePicker from "@/components/utils/HDatePicker.vue";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import {useResponsive} from "@/hooks/useResponsive.js";

  const props = defineProps(["hideNav","tag"]);
  const {isDesktop} = useResponsive();

  // 桌面 tab 内嵌(有 tag): 详情高度收进"视口内"(减去 Header 64 + 顶部 tab 行 ~52 + 留白),
  // 让详情在自己容器内部滚动, 整页不滚 → 左侧分类列(同排兄弟)自然固定不动。
  function calcRightHeight() {
    if (isDesktop.value && props.tag) {
      return window.innerHeight - 64 - 52 - 12;
    }
    return window.innerHeight - 64;
  }
  const rightHeight = ref(calcRightHeight());
  // 桌面独立页(无 tag): 用 CSS 100vh 计算高度, 始终跟随真实视口填满到底(避免 innerHeight 快照
  // 偏小导致底部留白); 其它场景仍用像素快照。返水页顶部 nav ~46px。
  const swiperHeight = computed(() =>
    // nav ~46px + 外层 flex 行上下各 5px 内边距 = 56px
    (isDesktop.value && !props.tag) ? 'calc(100vh - 56px)' : rightHeight.value
  );
  function onResizeRight() { rightHeight.value = calcRightHeight(); }
  onMounted(() => window.addEventListener('resize', onResizeRight));
  onUnmounted(() => window.removeEventListener('resize', onResizeRight));
  const activeSwiperIndex = ref(0);
  const swiperLrRef = ref();
  const leftIconInfo = ref([
    {
      title:"洗码返水",
      icon:icon_left_xmfs,
    },
    {
      title:"返水历史",
      icon:icon_left_fs,
    },
    {
      title:"洗码历史",
      icon:icon_left_xmjl,
    },
  ]);
  function changeSwiperPage(index){
    swiperLrRef.value.changeSwiperPage(index);
  }
  function onSwipeChange(index) {
    activeSwiperIndex.value = index;
  }

</script>


<style scoped>
  .eachLeftDiv{
    display: flex;flex-direction: row;align-items: center;border-radius: 6px;
    padding:10px 0;justify-content: center;margin-bottom: 12px;margin-right: 3px;
  }

  /* 桌面: <style>/inline 的 px 被转 vw, 左侧分类按钮过高; 拉回真实 px, 并给左列独立底色以区别右侧详情 */
  @media (min-width: 1024px) {
    .ximaLeftCol {
      background: #f3f4f9;
      border-radius: 10px;
      padding: 8px 6px;
      align-self: flex-start;
    }
    .eachLeftDiv {
      padding: 8px 0;
      margin-bottom: 8px;
      border-radius: 6px;
      /* 桌面: 每个分类按钮拉满列宽、内容居中(原来是内容宽度、左对齐, 显得没居中) */
      width: 100%;
      margin-right: 0;
      box-sizing: border-box;
    }
  }
</style>
